import { useTranslation } from 'react-i18next';
import React, { useContext, useEffect, useState } from "react"
import TopSearch from "@/components/TopSearch"
import ListComponent from "@/components/listComponent"
import { getRedEnvelopeList, syncRedEnvelopeStatus } from "@/service/customerService"
import { getUserList } from "@/service/customerService"
import { MyContext } from "@/store/myContext"
import { Card, List } from "antd"
import Modal from "antd/es/modal/Modal"
import i18n from 'i18next';
//红包管理
const redEnvelope = {
    NOTSEND: i18n.t(`customerManage.redEnvelope.index.未发放`),
    SENDING: i18n.t(`customerManage.redEnvelope.index.发放中`),
    SENT: i18n.t(`customerManage.redEnvelope.index.已发放待领取`),
    FAILED: i18n.t(`customerManage.redEnvelope.index.发放失败`),
    RECEIVED: i18n.t(`customerManage.redEnvelope.index.已领取`),
    RFUND_ING: i18n.t(`customerManage.redEnvelope.index.退款中`),
    REFUND: i18n.t(`customerManage.redEnvelope.index.已退款`),
}

const detailMap = {
    orderId: i18n.t(`customerManage.redEnvelope.index.订单`)+"id",
    sign: i18n.t(`customerManage.redEnvelope.index.签名`),
    remark: i18n.t(`customerManage.redEnvelope.index.备注`),
    actName: i18n.t(`customerManage.redEnvelope.index.活动名称`),
    deleteFlag: `${i18n.t(`customerManage.redEnvelope.index.删除标记`)};0:${i18n.t(`customerManage.redEnvelope.index.正常`)};1:${i18n.t(`customerManage.redEnvelope.index.已删除`)}`,
    wxResult: i18n.t(`customerManage.redEnvelope.index.微信返回的请求信息`),
    customerId: i18n.t(`customerManage.redEnvelope.index.客户`)+"id",
    sceneId: i18n.t(`customerManage.redEnvelope.index.场景`)+"id",
    id: "id",
    unionId: i18n.t(`customerManage.redEnvelope.index.用户唯一`)+"id",
    mchBillno: `${i18n.t(`customerManage.redEnvelope.index.商户订单号`)}28${i18n.t(`customerManage.redEnvelope.index.位`)}`,
    mchId: i18n.t(`customerManage.redEnvelope.index.商户`)+"id",
    sendName: i18n.t(`customerManage.redEnvelope.index.商户名称`),
    riskInfo: i18n.t(`customerManage.redEnvelope.index.活动信息`),
    throwInfo: i18n.t(`customerManage.redEnvelope.index.异常信息`),
    updateUser: i18n.t(`customerManage.redEnvelope.index.修改人`)+"id",
    updateTime: i18n.t(`customerManage.redEnvelope.index.修改时间`),
    wishing: i18n.t(`customerManage.redEnvelope.index.红包祝福语`),
    userId: i18n.t(`customerManage.redEnvelope.index.接受红包的用户`)+"id",
    wxappid: i18n.t(`customerManage.redEnvelope.index.公众账号`)+"appid",
    nonceStr: i18n.t(`customerManage.redEnvelope.index.随机字符串`),
    totalAmount: i18n.t(`customerManage.redEnvelope.index.付款金额`)+ i18n.t(`customerManage.redEnvelope.index.付款金额，单位分`),
    totalNum: i18n.t(`customerManage.redEnvelope.index.红包发放总人数`),
    createTime: i18n.t(`customerManage.redEnvelope.index.创建时间`),
    clientIp: "Ip"+i18n.t(`customerManage.redEnvelope.index.地址`),
    createUser: i18n.t(`customerManage.redEnvelope.index.创建人`)+"id",
    reOpenid: i18n.t(`customerManage.redEnvelope.index.用户`)+"openid",
    orderCode: i18n.t(`customerManage.redEnvelope.index.订单编号`),
    userName: i18n.t(`customerManage.redEnvelope.index.用户名称`),
    customerName: i18n.t(`customerManage.redEnvelope.index.客户名称`),
    status: i18n.t(`customerManage.redEnvelope.index.红包发放状态`),
}

export default () => {
    
const { t } = useTranslation();
const { state } = useContext(MyContext)
    const [list, setList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [detailVisible, setDetailVisible] = useState(false)
    const [current, setCurrent] = useState({})
    const [detailDateSource, setDetailDateSource] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (state.activeMenu === "redEnvelope") {
            loadData(pagination.current)
        }
    }, [state.activeMenu])// eslint-disable-line react-hooks/exhaustive-deps

    const showDetail = (record) => {
        setCurrent(record)
        console.log(current)
        let arr = Object.keys(record).map((k) => {
            let name = detailMap[k]
            let val = record[k]
            if ("status" === name) {
                val = redEnvelope[val]
            }
            return {
                name: name,
                val: val,
            }
        })
        setDetailDateSource(arr)
        setDetailVisible(true)
    }

    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
            startTime: search.startTime ? search.startTime : null,
            endTime: search.endTime ? search.endTime : null,
        }
        getRedEnvelopeList(data).then((res) => {
            // if (res && res.retCode === 200) {
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setList(res.retData.list)
            setLoading(false)
            // } else {
            //     message.warning(res.retMsg)
            // }
        })
        // .catch((err) => message.error(err.retMsg))
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //table配置
    const columns = [
        {
            title: t(`customerManage.redEnvelope.index.订单编号`),
            align: "center",
            dataIndex: "orderCode",
        },
        {
            title: t(`customerManage.redEnvelope.index.客户名称`),
            align: "center",
            dataIndex: "customerName",
        },
        {
            title: t(`customerManage.redEnvelope.index.用户名称`),
            align: "center",
            dataIndex: "userName",
        },
        {
            title: t(`customerManage.redEnvelope.index.红包金额`),
            align: "center",
            dataIndex: "totalAmount",
            render: (text) => <>{text / 100}</>,
        },
        {
            title: t(`customerManage.redEnvelope.index.发放状态`),
            align: "center",
            dataIndex: "status",
            render: (text) => <>{redEnvelope[text]}</>,
        },
        {
            title: t(`customerManage.redEnvelope.index.红包祝福语`),
            align: "center",
            dataIndex: "wishing",
        },
        {
            title: t(`customerManage.redEnvelope.index.红包发放总人数`),
            align: "center",
            dataIndex: "totalNum",
        },
        {
            title: t(`customerManage.redEnvelope.index.操作`),
            align: "center",
            width: 100,
            render: (text, record) => (
                <button
                    onClick={() => {
                        showDetail(record)
                    }}
                >
                    {" "}
                    {t(`customerManage.redEnvelope.index.查看详情`)}
                </button>
            ),
        },
    ]
    //搜索JSON
    const searchList = {
        normalList: [
            {
                type: "input",
                placeholder: t(`customerManage.redEnvelope.index.请输入订单`)+"id",
                valueName: "orderId",
            },
            {
                type: "input",
                placeholder: t(`customerManage.redEnvelope.index.请输入订单`)+"Code",
                valueName: "orderCode",
            },
            {
                type: "searchSelect",
                placeholder: t(`customerManage.redEnvelope.index.请选择用户`),
                valueName: "userId",
                optionName: "userName",
                optionId: "id",
                searchApi: getUserList,
            },
            // {
            //     type: "input",
            //     placeholder: "请输入用户Id",
            //     valueName: "userId",
            // },
            {
                type: "input",
                placeholder: t(`customerManage.redEnvelope.index.请输入用户名称`),
                valueName: "userName",
            },
            {
                type: "input",
                placeholder: t(`customerManage.redEnvelope.index.请输入客户名称`),
                valueName: "customerName",
            },
            {
                type: "input",
                placeholder: t(`customerManage.redEnvelope.index.微信商户号`),
                valueName: "mchBillno",
            },
            {
                type: "RangePicker",
                valueName: ["startTime", "endTime"],
                span: 16,
                xxl: 8,
            },
        ],
    }

    function handleDetails(mode) {
        if ("sync_status" === mode) {
            setLoading(true)
            syncRedEnvelopeStatus().then((res) => {
                loadData(pagination.current)
            })
        }
    }

    //列表button
    const topButtons = [
        {
            click: () => handleDetails("sync_status"),
            content: t(`customerManage.redEnvelope.index.同步红包发送状态`),
        },
    ]

    return (
        <>
            {state.activeMenu === "redEnvelope" && (
                <>
                    <TopSearch
                        justify="start"
                        title= {t(`customerManage.redEnvelope.index.红包管理`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`customerManage.redEnvelope.index.红包管理`)}
                        loading={loading}
                        columns={columns}
                        dataSource={list}
                        pagination={pagination}
                        buttons={topButtons}
                        onTableChange={onTableChange}
                    />
                    <Modal
                        visible={detailVisible}
                        onOk={() => {
                            setDetailVisible(false)
                            setCurrent({})
                        }}
                        onCancel={() => {
                            setDetailVisible(false)
                            setCurrent({})
                        }}
                        width={"80%"}
                    >
                        <div className="list-container">
                            <div className="form-details-warp">
                                <List
                                    grid={{
                                        gutter: 16,
                                        xs: 1,
                                        sm: 2,
                                        md: 4,
                                        lg: 4,
                                        xl: 6,
                                        xxl: 3,
                                    }}
                                    dataSource={detailDateSource}
                                    renderItem={(item) => (
                                        <List.Item>
                                            <Card title={item.name}> {item.val}</Card>
                                        </List.Item>
                                    )}
                                />
                            </div>
                        </div>
                    </Modal>
                </>
            )}
        </>
    )
}
